import { arrayOfObjectsToCSV } from "helpers/arrayOfObjectsToCsv";
import downloadFile from "helpers/downloadFile";
import formatTimestamp, { formatTime } from "helpers/formatTimestamp";

const useExportToCsv = <T extends GenericObject>({ data, name }: { data: T[], name: string }) => {
    const exportCsv = () => {
        const file = arrayOfObjectsToCSV(data);
        const timestamp = new Date().toString();
        downloadFile(`${name} - ${formatTimestamp(timestamp)} - ${formatTime(timestamp)}.csv`, file);
    };

    return {
        exportCsv
    };
};

export default useExportToCsv;
